// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let NotePathListView
require("./styles/note-path-list.css")
require("./styles/note-path-item.css")

const NoteListView = require("./note-list").default

class NotePathItemView extends require("lib/static-shim").default(
  require("lib/core/layout").default
) {
  static initClass() {
    this.prototype.tagName = "li"

    this.prototype.regions = {
      noteList: "#notes-list",
      stepList: "#steps-list"
    }

    this.prototype.triggers = { "click .add-note": "add:note" }

    this.prototype.behaviors = {
      ConnectStore: {
        stores: [
          { store: "path" },
          {
            store: "note",
            events: {
              "note:removed": "transitionDestroy"
            }
          }
        ]
      }
    }
  }
  getTemplate() {
    return require(`./templates/note-path-${this.getItemType()}-item.html`)
  }
  className() {
    return `note-path-item-view path-${this.getItemType()}`
  }

  getItemType() {
    switch (this.model.get("item_type")) {
      case "G":
        return "group"
      case "A":
        return "step"
      case "R":
        return "resource"
      default:
        null
    }
  }

  onRender() {
    this.noteListView = new NoteListView({
      collection: this.noteStore.request.getTargetForItem(this.model).notes
    })
    this.noteList.show(this.noteListView)
    this.noteListView.$el.addClass(this.getItemType())

    // The note list view listens to its child views
    this.listenTo(this.noteListView, "show:note:form", function (note) {
      return this.triggerMethod("show:note:form", note)
    })

    if (this.getItemType() === "group") {
      const stepNotes = __guard__(this.model.get("items"), (x) =>
        x.filter((step) => {
          return __guard__(
            this.noteStore.request.getTargetForItem(step),
            (x1) => x1.notes.length
          )
        })
      )
      if (stepNotes.length) {
        this.notePathListView = new NotePathListView({
          collection: new Backbone.Collection(stepNotes)
        })
        return this.stepList.show(this.notePathListView)
      }
    }
  }

  onShow() {
    return this.transitionChildViews()
  }

  onAddNote() {
    return Pathwright.vent.trigger("add:note", this.model)
  }

  transitionChildViews() {
    return $.Velocity.animate(this.$el, "transition.slideRightIn", {
      duration: 350
    })
  }

  transitionDestroy(note) {
    const { can_modify } =
      window.App.getStore("note").request.getNotePermissions()
    if (!can_modify) {
      return
    }
    // Destroying the view when its noteListView's collection is empty.
    if (note.get("context").step !== this.model.get("sync_source_id")) {
      return
    }
    const target =
      this.noteStore.get("notes_per_target")[note.get("context").step]
    if (target.total_notes) {
      return
    }
    return $.Velocity.animate(this.$(".note-item-name"), "transition.fadeOut", {
      duration: 300,
      easing: "easeOut"
    }).then(() => {
      return _.delay(() => {
        return this.destroy()
      }, 300)
    })
  }

  serializeData() {
    const data = super.serializeData()
    data.permissions = window.App.getStore("note").request.getNotePermissions()
    return data
  }
}
NotePathItemView.initClass()

export default NotePathListView = (function () {
  NotePathListView = class NotePathListView extends (
    require("lib/static-shim").default(
      require("lib/core/composite-view").default
    )
  ) {
    static initClass() {
      this.prototype.template = require("./templates/note-path-list.html")
      this.prototype.className = "note-path-list-view"
      this.prototype.tagName = "ul"
      this.prototype.childView = NotePathItemView
      this.prototype.childViewContainer = this.el

      this.prototype.childEvents = {
        "show:note:form"(childView, note) {
          return Pathwright.vent.trigger("show:note:form", note)
        }
      }
    }
  }
  NotePathListView.initClass()
  return NotePathListView
})()

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
